export const iconsSwitchData = [
    {
      color: "primary",
      header: "Primary Switch",
    },
    {
      color: "secondary",
      header: "secondary Switch",
    },
    {
      color: "success",
      header: "success Switch",
    },
    {
      color: "danger",
      header: "Danger Switch",
    },
    {
      color: "warning",
      header: "Warning Switch",
    },
    {
      color: "info",
      header: "Info Switch",
    },
    {
      color: "dark",
      header: "Dark Switch",
    },
  ];
  export const unCheckedSwitchData = [
    {
      color: "primary",
      header: "Unchecked Primary Switch",
    },
    {
      color: "secondary",
      header: "Unchecked secondary Switch",
    },
    {
      color: "success",
      header: "Unchecked success Switch",
    },
    {
      color: "danger",
      header: "Unchecked Danger Switch",
    },
    {
      color: "warning",
      header: "Unchecked Warning Switch",
    },
    {
      color: "info",
      header: "Unchecked Info Switch",
    },
    {
      color: "dark",
      header: "Unchecked Dark Switch",
    },
  ];

  export const borderedSwitchData = [
    {
      color: "primary",
      header: "Bordered Primary Switch",
    },
    {
      color: "secondary",
      header: "Bordered secondary Switch",
    },
    {
      color: "success",
      header: "Bordered success Switch",
    },
    {
      color: "danger",
      header: "Bordered Danger Switch",
    },
    {
      color: "warning",
      header: "Bordered Warning Switch",
    },
    {
      color: "info",
      header: "Bordered Info Switch",
    },
    {
      color: "dark",
      header: "Bordered Dark Switch",
    },
  ];

  export const switchColor = ["primary","secondary","success","danger","warning","info","dark"];

  export const disabledOutlineSwitchHeaderData = [
    {
      text: "Use the",
      code: ".switch-outline ",
    },
    {
      text: "class through created outline. ",
    },
  ];

  export const variationOfSwitchHeaderData = [
    {
      text: "Use the",
      code: ".tgl-skewed/tgl-flip",
    },
    {
      text: " class through created variations. ",
    },
  ];
  
  export const variationOfSwitchesData = [
    { mediaBodyClass: "icon-state", color: "warning" },
    { heading: "Checked" },
    { color: "success" },
    { heading: "Flat" },
  ];

  export const switchSizingHeaderData = [
    {
      text: "Use the",
      code: ".switch-sm",
    },
    {
      text: "and",
      code: ".switch-lg ",
    },
    { text: "class through defined switch sizing." },
  ];

  export const commonSwitchSizeData = [
    {
      tittle: "Small Size",
      mediaBodyClassName: "switch-sm",
      defaultChecked: true,
    },
    { tittle: "Small Size Unchecked", mediaBodyClassName: "switch-sm" },
    { tittle: "Normal Size", defaultChecked: true },
    { tittle: "Normal Unchecked" },
    { tittle: "Disabled State", disabled: true },
    {
      tittle: "Large Size",
      mediaBodyClassName: "switch-lg",
      defaultChecked: true,
    },
    { tittle: "Large Unchecked", mediaBodyClassName: "switch-lg" },
    { tittle: "Disabled", mediaBodyClassName: "switch-lg", disabled: true },
  ];

  export const switchSizingWithIconsHeaderData = [
    {
      text: "Use the",
      code: ".icon-state ",
    },
    {
      text: "class through visible icons in switches.",
    },
  ];